import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'dynamic-entry-active-listing-error',
  styleUrl: 'dynamic-entry-active-listing-error.css',
})
export class DynamicEntryVinActiveListing {
  @Prop() model: string = '';
  @Prop() trim: string = '';
  @Prop() vin: string = '';
  @Prop() yearId: number = 0;
  @Prop() make: string = '';
  @Prop() errorMessage: string = '';
  @Prop() changeVehicle: Function = () => {};
  @Prop() vinActiveDealerUrl: string = '';
  @Prop() hasVinActiveAutotraderListingError: boolean = false;

  render() {
    return (
      <div class="dynamic-entry-active-listing-error-base-font my-auto">
        <div class="flex flex-col mb-10">
          <div class="flex flex-col">
            <div>
              <span class="dynamic-entry-active-listing-error font-bold leading-6">
                <svg-icon icon="icon-alert" width="1em" height="1em" class="mr-2 dynamic-entry-active-listing-error-icon"></svg-icon>
                {this.errorMessage}
              </span>
              {this.vinActiveDealerUrl && this.hasVinActiveAutotraderListingError && (
                <ico-hyperlink
                  href={this.vinActiveDealerUrl}
                  class="dynamic-entry-active-listing-error-link text-white text-center block decoration-white/50 ml-5 font-thin"
                  content="primary"
                  target="_blank"
                  rel="noopener noreferrer">
                  Click here to see listing
                </ico-hyperlink>
              )}
            </div>
          </div>
        </div>

        <div class="flex gap-x-2 justify-center text-xs">
          <ico-hyperlink
            data-testid="bi-btn-change-vehicle"
            content="primary"
            href=""
            onClick={(e) => {
              e.preventDefault();
              this.changeVehicle();
            }}>
            Change Vehicle
          </ico-hyperlink>
        </div>
      </div>
    );
  }
}
